import { render, staticRenderFns } from "./Productores.vue?vue&type=template&id=33341170&scoped=true"
import script from "./Productores.vue?vue&type=script&lang=js"
export * from "./Productores.vue?vue&type=script&lang=js"
import style0 from "./Productores.vue?vue&type=style&index=0&id=33341170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33341170",
  null
  
)

export default component.exports